import { crearWhatsAppUrl } from '../../../utils/contactos';

export const createWhatsAppUrl = (message = '') =>
  crearWhatsAppUrl('catalogo', message || 'Hola, solicito información sobre los equipos de CAPSOS Telecomunicaciones.');
